import { Block } from '@/components/crRender'
import { translate } from '@/utils/langUtils'
import React from 'react'
import BillList from '../BillList'

const PricingItem = ({ title, price, detailsList = [], isRender = true }) => {
    return (
        <>
            <Block isRender={isRender} className="qd-summary-item">
                <span className="qd-summary-label">{translate(title) || title}</span>
                <span className="qd-summary-value">${price}</span>
            </Block>
            <BillList List={detailsList} />
        </>
    )
}

export default PricingItem